import { theme } from "../../utils/theme";

export const styles = {
  background: {
    // background:
    //   "linear-gradient(0deg, #EBF4FB 30%, rgba(235, 244, 251, 0) 70%)",
    // backgroundColor: theme.palette.background.muted,
    // backgroundColor: theme.palette.grays.white,
    height: "100%",
    right: { xs: 0, sm: 0 },
    top: { xs: 0, sm: 0 },
    position: "absolute",
    width: "100%",
    zIndex: -1,
  },
  body: {
    alignItems: "start",
    display: "flex",
    justifyContent: "center",
    mt: 0,
    position: "relative",
  },
  bodyText: {
    color: theme.palette.grays[100],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.fontSize * 1.13,
    },
    fontWeight: 300,
    mb: { xs: 4, md: 0 },
    mt: { xs: 6, md: 6 },
    textAlign: { xs: "start", md: "start" },
    textTransform: "none",
  },
  footerText: {
    color: theme.palette.accent.main,
    fontSize: {
      xs: theme.typography.fontSize * 1,
      md: theme.typography.fontSize * 1,
    },
    mt: { xs: 4, md: 4 },
    textAlign: { xs: "end", md: "end" },
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  item: {
    alignItems: "start",
    backgroundColor: theme.palette.grays[100],
    borderColor: theme.palette.grays[300],
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: "none",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    mb: 3,
    mt: 3,
    pb: 8,
    pl: 7,
    pr: 7,
    pt: 6,
    transition: "all 0.3s ease-in-out",
    // "&:hover": {
    //   boxShadow: "0 4px 32px rgba(0,0,0,.2)",
    // },
  },
  itemAction: {
    alignItems: "center",
    color: theme.palette.primary.main,
    cursor: "pointer",
    display: "flex",
    fontSize: {
      xs: theme.typography.fontSize * 1.13,
      md: theme.typography.fontSize * 1.13,
    },
    fontWeight: 700,
    justifyContent: "end",
    mt: 4,
    width: "100%",
  },
  itemHeader: {
    color: theme.palette.grays[900],
    fontSize: {
      xs: theme.typography.h4,
      md: theme.typography.h3,
    },
    fontWeight: 700,
    letterSpacing: 1.2,
    lineHeight: 1.2,
    mb: 2,
    mt: 1,
    textAlign: "start",
    // transition: "all 0.3s ease-in-out",
  },
  itemImage: {
    backgroundPosition: "left top !important",
    backgroundRepeat: "no-repeat !important",
    backgroundSize: "contain !important",
    height: 60,
    width: "100%",
  },
  itemSubheader: {
    color: theme.palette.grays[800],
    fontSize: {
      xs: theme.typography.body2,
      md: theme.typography.body,
    },
    fontWeight: 500,
    letterSpacing: 1.2,
    lineHeight: 1.1,
    textAlign: "start",
  },
  itemText: {
    color: theme.palette.grays[800],
    fontSize: {
      xs: theme.typography.body2,
      md: theme.typography.body,
    },
    fontWeight: 500,
    // letterSpacing: 0.9,
    lineHeight: 1.1,
    textAlign: "start",
  },
  margin: {
    display: "flex",
    margin: 1,
  },
  sectionHeader: {
    alignItems: "center",
    color: theme.palette.secondary.main,
    display: "flex",
    fontSize: {
      xs: theme.typography.h3,
      md: theme.typography.h3,
    },
    fontWeight: 700,
    letterSpacing: 1.2,
    lineHeight: 1.2,
    mb: 5,
    mt: 12,
    textAlign: "start",
  },
};
